import { lStorage } from '..';
import { format, parse } from 'date-fns';
import {
	DATE_FORMAT_FNS,
	TIME_WITH_PERIOD_FORMAT_FNS,
	BE_DATE_FORMAT_FNS,
} from 'modules/utils';

const getDayMonthFormat = userDateFormat => {
	const dayOrMonthFirst = userDateFormat.split('/')[0];
	switch (dayOrMonthFirst) {
		case 'dd':
			return 'd/L';
		case 'mm':
			return 'L/d';
		case 'yyyy':
			return 'L/d';
		default:
			return 'L/d';
	}
};

const getShortYearFormat = userDateFormat => {
	switch (userDateFormat) {
		case 'dd/MM/yyyy':
			return 'dd/MM/yy';
		case 'MM/dd/yyyy':
			return 'MM/dd/yy';
		case 'yyyy/MM/dd':
			return 'yy/MM/dd';
		default:
			return 'MM/dd/yy';
	}
};

const toDateObject = (date, stringDateFormat) =>
	typeof date === 'string' ? parse(date, stringDateFormat, new Date()) : date;

const getDateFormat = dateFormat => {
	const selectedDateFormat = lStorage.get({ key: 'current-user' }).user
		.dateFormat;
	return dateFormat || selectedDateFormat || DATE_FORMAT_FNS;
};

/**
 *
 * @param {(string|Date)} date string or DateObject to be formatted
 * @param {string} [options.dateFormat] - Date-fns date format instead of user preferred from local storage
 * @param {string} [options.timeFormat] - Date-fns time format
 * @param {boolean} [options.timeOnly] - Boolean to return time without the date
 * @param {boolean} [options.dayAndMonthOnly] - Boolean to return only day and month, ex. 24/03 or 03/24
 * @param {boolean} [options.shortYear] - Boolean to return date with 2 digit year, ex. 03/24/17
 * @param {string} [options.stringDateFormat] - Required format of string date is passed,'dd/MM/yyyy' for '25/10/2019'
 * @returns {string}
 */
export const dateFormatter = (date, options = {}) => {
	const {
		dateFormat = '',
		timeFormat = '',
		timeOnly = false,
		dayAndMonthOnly = false,
		shortYear = false,
		stringDateFormat = BE_DATE_FORMAT_FNS,
	} = options;

	const actualDateFormat = getDateFormat(dateFormat);
	const fullDateFormat = `${actualDateFormat} ${timeFormat}`.trim();
	const dateObj = toDateObject(date, stringDateFormat);

	if (dayAndMonthOnly) {
		const dayAndMonthFormat = getDayMonthFormat(actualDateFormat);
		return format(dateObj, dayAndMonthFormat);
	}

	if (timeOnly) {
		const timeOnlyFormat = timeFormat || TIME_WITH_PERIOD_FORMAT_FNS;
		return format(dateObj, timeOnlyFormat);
	}

	if (shortYear) {
		const shortYearFormat = getShortYearFormat(actualDateFormat);
		return format(dateObj, shortYearFormat);
	}

	return format(dateObj, fullDateFormat);
};
